var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.user.role == 1)?_c('div',{},[_c('PageHeader',{attrs:{"label":"Activities for this client"}}),_c('div',{staticClass:"mt-6"},[_c('ActivityList')],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }